import './orchestrators/logPerformanceDatapoint';

export { addSearchRequestInstrumentation } from './actions/addSearchRequestInstrumentation';
export { addResourceTimingEntry } from './actions/addResourceTimingEntry';
export { SearchDiagnosticsPanel } from './components/SearchDiagnosticsPanel';
export { searchDiagnostics } from './store/store';
